import Keycloak from "keycloak-js";

// The realm is derived from the subdomain: <tenant>.instantview.ai logs into
// the <tenant> realm, and app.instantview.ai (and the bare domain) into the
// founding tenant's.
//
// The two fallbacks used to be hardcoded literals, which is the M2
// carry-forward this discharges: a second tenant needs the default to be
// configuration, not a string in the bundle. Both keep their existing values
// as defaults, so local development and today's deployment are unchanged.
const DEFAULT_REALM = process.env.REACT_APP_DEFAULT_REALM || "instantviewai";
const PLATFORM_REALM = process.env.REACT_APP_PLATFORM_REALM || "platform";

const host = window.location.hostname;
const parts = host.split(".");

let subdomain;
if (parts.length > 2) {
	const firstPart = parts.slice(0, -2).join(".").toLowerCase();
	subdomain = firstPart === "app" ? DEFAULT_REALM : firstPart;
} else {
	subdomain = DEFAULT_REALM;
}

export const realm = subdomain;

// The operator console is served from the same bundle on
// platform.instantview.ai. index.js branches on this to choose a router --
// it is a UI branch only; the API refuses on its own, from the token.
export const isPlatformRealm = realm === PLATFORM_REALM;

const keycloak = new Keycloak({
	url: "https://identity.instantview.ai",
	realm,
	clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export default keycloak;
